<div
  (click)="closeHeader.emit()"
  (keydown.enter)="closeHeader.emit()"
  (keydown.space)="closeHeader.emit()"
  tabindex="0"
  role="button"
  aria-label="Close"
  class="close-header-button"
  id="mach-core-header-close-button"
>
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.001 1.66016L10.1494 9.50098L17.9971 17.3398L16.835 18.5L8.98828 10.6621L1.16504 18.4766L0.00390625 17.3164L7.82617 9.50098L0 1.68359L1.16211 0.523438L8.98828 8.34082L16.8389 0.5L18.001 1.66016Z"
      fill="white"
    />
  </svg>
</div>
